module.exports = require("./ka-GE.js");